import { Files } from "lucide-react";
import { useCategories } from "../hooks/useCategories";
import { tr } from "../lib/i18n";

export const CategoryFilterDock = ({ active, setActive, counts = {}, total = 0 }) => {
  const { all } = useCategories();
  const tabs = [
    { key: "all", label: "All Documents", icon: Files, count: total },
    ...all.map((c) => ({
      key: c.key,
      label: c.label,
      icon: c.icon,
      count: counts[c.key] || 0,
    })),
  ];

  return (
    <div
      data-testid="category-filter-dock"
      className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1 scrollbar-none"
    >
      {tabs.map((t) => {
        const isActive = active === t.key;
        const Icon = t.icon;
        return (
          <button
            key={t.key}
            data-testid={`cat-tab-${t.key}`}
            onClick={() => setActive(t.key)}
            className={`folder-tab shrink-0 flex items-center gap-2 rounded-t-xl rounded-b-md border px-4 py-2.5 text-sm font-medium ${
              isActive
                ? "bg-primary text-primary-foreground border-primary shadow-sm -translate-y-0.5"
                : "bg-card text-foreground/80 border-border hover:bg-accent"
            }`}
          >
            <Icon className="h-4 w-4" />
            {tr(t.label)}
            <span
              className={`ml-1 text-xs font-mono rounded-full px-1.5 py-0.5 min-w-[20px] text-center ${
                isActive ? "bg-primary-foreground/20" : "bg-muted text-muted-foreground"
              }`}
            >
              {t.count}
            </span>
          </button>
        );
      })}
    </div>
  );
};
